import React, { useCallback, useState } from 'react';
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { vscDarkPlus } from 'react-syntax-highlighter/dist/esm/styles/prism';

type CodeBlockProps = {
  code: string;
  language?: string;
  ariaLabel?: string;
};

export const CodeBlock: React.FC<CodeBlockProps> = ({ code, language = 'html' }) => {
  const [copied, setCopied] = useState(false);

  const onCopy = useCallback(async () => {
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(code);
      } else {
        const ta = document.createElement('textarea');
        ta.value = code;
        ta.style.position = 'fixed';
        ta.style.left = '-9999px';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
      }
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1500);
    } catch (err) {
      console.error('Copy failed', err);
    }
  }, [code]);

  return (
    <div className="relative overflow-hidden rounded-xl border border-slate-800 shadow-[inset_0_0_0_1px_rgba(0,0,0,0.25)]">
      <button
        className="absolute right-2 top-2 rounded-md border border-slate-700 bg-white/10 px-2.5 py-1 text-xs hover:bg-white/15"
        onClick={() => void onCopy()}
        aria-live="polite"
        aria-label={copied ? 'Copied' : 'Copy to clipboard'}
        title={copied ? 'Copied!' : 'Copy to clipboard'}
      >
        {copied ? 'Copied!' : 'Copy'}
      </button>
      <SyntaxHighlighter language={language} style={vscDarkPlus} customStyle={{ margin: 0 }} showLineNumbers>
        {code.trim()}
      </SyntaxHighlighter>
    </div>
  );
};

export default CodeBlock;
